<template>
    <div>
        <v-card>
            <div style="cursor:default">
                <v-card-title>Complaints and compensation overview
                    <v-spacer></v-spacer>
                    <v-btn class="primary ma-2" x-small @click="showDetails()" v-if="overview.numberOfClaims > 0" >Details</v-btn>
                </v-card-title>       
                <v-row class="mr-7">
                    <v-col cols="12" class="ml-5 mb-4">
                        <overview_table :overview="overview"/>
                    </v-col>
                </v-row>             
            </div>
        </v-card>
    </div>
</template>

<script>

    import overview_table from '@/components/huov/hokl/overview_table.vue';

    export default {
        props: {
            klnt_encrid: String,
        },     
        mounted(){
            this.getOverview();
        },   
        components: {
            overview_table
        },      
        data() {
            return {
                overview: {
                  numberOfClaims: 0,  
                },
            }
        },
        methods: {                    
            getOverview(){
                console.log('klnt_recid', this.klnt_encrid);
                this.$axios
                    .post("ares/json/ares/klnt/hokl/getKlntHokl.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getKlntHokl"
                        },
                        getKlntHokl: {
                            klnt_encrid: this.klnt_encrid
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {                   
                            console.log(res.data);
                            this.overview = res.data.getKlntHokl;         
                        }
                    });   
            }, 
            showDetails() {
                let route = this.$router.resolve({ path: '/task/customer_success/hokl/hokl_overview/klnt:' + this.klnt_encrid}); 
                window.open(route.href, '_blank');
            }             
        }
    }
</script>

<style scoped>

</style>